export class User {
  username: string;
  password: string;
  token: string;
  isMissionaryUser: string;
  userId: number;
}
